import { LegalAdDTO } from "../DTO/legalAdDTO";
import { AbstractDocument } from "./abstractDocument";
import { LegalAdAuction } from "./legalAdAuction";

export class LegalAd{

    public id!:number;
    public state!:string;
    public county!:string;
    public countyId!:number;
    public documentReference!:string;
    public createdAt!:Date;
    public createdByUser!:string;
    public submittedAt?:Date;
    public submittedByUser?:string;
    public submittedManual:boolean = false;
    public submittedTo?:string;
    public confirmedAt?:Date;
    public confirmedByUser?:string;
    public publishingDatesCount?:number;
    public publishingDates?:Date[];
    public legalAdAuctions?:LegalAdAuction[];

    private abstractDocument?:AbstractDocument;

    constructor(){
    }

    public static mapToDTO(param:LegalAd) : LegalAdDTO{
        
        let dto = new LegalAdDTO();
        try
        {
            dto.id = param.id;
            dto.state = param.state;
            dto.county = param.county;
            dto.countyId = param.countyId;
            dto.documentReference = param.documentReference;
            dto.createdAt = param.createdAt.toLocaleDateString();
            dto.createdByUser = param.createdByUser;
            if(param.submittedAt) dto.submittedAt = param.submittedAt.toLocaleDateString();
            dto.submittedByUser = param.submittedByUser;
            dto.submittedManual = param.submittedManual
            dto.submittedTo = param.submittedTo;
            if(param.confirmedAt) dto.confirmedAt = param.confirmedAt.toLocaleDateString();
            dto.confirmedByUser = param.confirmedByUser;
            dto.publishingDatesCount = param.publishingDatesCount;
            if(param.publishingDates) dto.publishingDates = param.publishingDates.map(pd=>pd.toLocaleDateString());
            if(param.legalAdAuctions) dto.legalAdAuctions = param.legalAdAuctions.map(laa=>LegalAdAuction.mapToDTO(laa));
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:LegalAdDTO) : LegalAd
    {
        
        let obj = new LegalAd();
        try
        {
            obj.id = param.id;
            obj.state = param.state;
            obj.county = param.county;
            obj.countyId = param.countyId;
            obj.documentReference = param.documentReference;
            if(param.createdAt) obj.createdAt = obj.timezoneNeutralDate(param.createdAt);
            obj.createdByUser = param.createdByUser;
            if(param.submittedAt) obj.submittedAt = obj.timezoneNeutralDate(param.submittedAt);
            obj.submittedByUser = param.submittedByUser;
            obj.submittedManual = param.submittedManual
            obj.submittedTo = param.submittedTo;
            if(param.confirmedAt) obj.confirmedAt = obj.timezoneNeutralDate(param.confirmedAt);
            obj.confirmedByUser = param.confirmedByUser;
            obj.publishingDatesCount = param.publishingDatesCount;
            if(param.publishingDates) obj.publishingDates = param.publishingDates.map(pd=>obj.timezoneNeutralDate(pd));
            if(param.legalAdAuctions) obj.legalAdAuctions = param.legalAdAuctions.map(laa=>LegalAdAuction.mapFromDTO(laa));
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    get canEditSubmitted(){
        return (!this.submittedAt || (this.submittedAt && this.submittedManual));
    }

    get canEditConfirmed(){
        return this.submittedAt;
    }

    get canEditPublishingDates(){
        return this.canEditConfirmed;
    }

    get isSubmitted(){
        return this.submittedAt?true:false;
    }

    get isConfirmed(){
        return this.confirmedAt?true:false;
    }

    get isAllVoid(){
        return this.legalAdAuctions?.every(laa=>laa.void===true);
    }

    get isPartialVoid(){
        return !this.isAllVoid && this.legalAdAuctions?.some(laa=>laa.void===true);
    }

    get createdStatusDisplayText(){
        return 'Created at ' + this.createdAt.toLocaleDateString() + ' by ' + this.createdByUser;
    }
    get submittedStatusDisplayText(){
        return this.submittedAt?('Submitted at ' + this.submittedAt.toLocaleDateString() + ' by ' + this.submittedByUser):' Not submitted';
    }
    get confirmedStatusDisplayText(){
        return this.confirmedAt?('Confirmed at ' + this.confirmedAt.toLocaleDateString() + ' for dates: ' + this.publishingDatesDisplayText):' Not confirmed';
    }
    get publishingDatesDisplayText(){
        return this.publishingDates?.length ? (this.publishingDates.map(pd=>pd.toLocaleDateString()).join(', ') || ''):'unknown';
    }

    get abstract(){
        if(!this.abstractDocument){
            this.abstractDocument = new AbstractDocument();
            this.abstractDocument.id=this.id;
            this.abstractDocument.name="Legal Ad";
            this.abstractDocument.description=this.county;
            this.abstractDocument.typeId=2;
            this.abstractDocument.date=this.createdAt;
            this.abstractDocument.isLegalAd=true;
            this.abstractDocument.contentType="text/pdf";
            this.abstractDocument.visibility=9;
            this.abstractDocument.documentReference=this.documentReference;
        }
        return this.abstractDocument;
    }

    private timezoneNeutralDate(value:string):Date{
        var date = new Date(value)
        var userTimezoneOffset = date.getTimezoneOffset() * 60000;
        return new Date(date.getTime() + userTimezoneOffset);
    }
}